import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ComponentsModule } from '@client/app/components/components.module';
import { PrivacyHistoryLineChartComponent } from './components/history-line-chart/history-line-chart.component';
import {
    LayoutModule,
    MonDatePickerModule,
    MonEventTriggerModule,
    MonTableSortModule,
} from '@monsido/angular-shared-components';
import { DoughnutComponent } from '@client/app/modules/charts/components/doughnut.component';
import { TranslateModule } from '@client/app/modules/translate.module';
import { NgbProgressbar, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { UpgradePipeModule } from '@client/app/filters/upgrade-pipe.module';
import { UIRouterModule } from '@uirouter/angular';
import { LineComponent } from '@client/app/modules/charts/components/line.component';
import { PrivacySummaryComponent } from './pages/summary/privacy-summary.component';
import { PrivacyListComponent } from './pages/list/list.component';
import { PrivacyIssuesComponent } from './pages/issues/privacy-issues.component';
import { PrivacyChecklistComponent } from './pages/checklist/privacy-checklist.component';
import { PrivacyDialogsFastTrackComponent } from './dialogs/fast-track/privacy-dialogs-fast-track.component';
import { ExportModule } from '@client/app/modules/export/export.module';
import { DataPrivacyModule } from '@monsido/modules/data-privacy/data-privacy.module';
import {
    DomainDataPrivacySettingsComponent,
} from '@client/app/modules/data-privacy/components/domain-settings/domain-data-privacy-settings.component';
import { FormsModule } from '@angular/forms';
import {
    MonDataPrivacyInfoTypeIconModule,
} from '@monsido/modules/data-privacy/components/info-type-icon/info-type-icon.module';
import { ExtensionModule } from '@client/app/modules/extension/extension.module';
import { MonDataPrivacyDropdownComponent } from '@monsido/modules/data-privacy/components/dropdown/dropdown.component';
import { PrivacyDialogsHelpCenterComponent } from './dialogs/help-center/help-center.component';
import { MonActionMenuModule } from '@client/ng2/shared/components/action-menu/action-menu.module';
import { PrivacyViolationPagesComponent } from './dialogs/violation-pages/privacy-violation-pages.component';
import { CookieAcceptanceRateComponent } from '../cookie-banner/components/cookie-acceptance-rate/cookie-acceptance-rate.component';
import { StatisticsModule } from '@client/app/pages/statistics/statistics.module';
import { CookieBannerTrafficLightComponent } from '../cookie-banner/components/cookie-banner-traffic-light/cookie-banner-traffic-light.component';
import { MonTabControlDirective } from '@client/app/directives/mon-tab-control/mon-tab-control.directive';
import { CookieBannerCookieOverviewComponent } from '../cookie-banner/components/cookie-overview/cookie-banner-cookie-overview.component';
import { MonCookieBannerModule } from '@client/ng2/modules/cookie-banner/cookie-banner.module';
import { ModalsDirectivesModule } from '@client/app/modules/modals/directives/modals-directives.module';
import { CookieOverviewComponent } from '../cookie-banner/pages/cookie-overview/cookie-overview.component';
import { CookieAcceptanceRateOverviewComponent } from '../cookie-banner/pages/cookie-acceptance-rate-overview/cookie-acceptance-rate-overview.component';
import { ConsentLogComponent } from '../cookie-banner/pages/consent-log/consent-log.component';
import { DatePickerComponent } from '@client/app/components/date-picker/date-picker.component';

@NgModule({
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [
        CommonModule,
        ComponentsModule,
        LayoutModule,
        DoughnutComponent,
        TranslateModule,
        NgbTooltip,
        UpgradePipeModule,
        UIRouterModule,
        LineComponent,
        ExportModule,
        DataPrivacyModule,
        MonEventTriggerModule,
        FormsModule,
        MonDataPrivacyInfoTypeIconModule,
        MonTableSortModule,
        ExtensionModule,
        MonDataPrivacyDropdownComponent,
        MonActionMenuModule,
        NgbProgressbar,
        StatisticsModule,
        MonCookieBannerModule,
        ModalsDirectivesModule,
        MonDatePickerModule,
        DatePickerComponent,
    ],
    exports: [],
    declarations: [
        PrivacyHistoryLineChartComponent,
        PrivacySummaryComponent,
        PrivacyListComponent,
        PrivacyIssuesComponent,
        PrivacyChecklistComponent,
        DomainDataPrivacySettingsComponent,
        PrivacyDialogsFastTrackComponent,
        PrivacyDialogsHelpCenterComponent,
        PrivacyViolationPagesComponent,
        CookieAcceptanceRateComponent,
        CookieBannerTrafficLightComponent,
        MonTabControlDirective,
        CookieBannerCookieOverviewComponent,
        CookieOverviewComponent,
        CookieAcceptanceRateOverviewComponent,
        ConsentLogComponent,
    ],
    providers: [],
})
export class UpgradeDataPrivacyModule {}
